import React from 'react'
import { Link } from 'react-router-dom'

const NoticeEventTableComponent = ({ data, notice, event }) => {
    // if(event){
    //     console.log("dfattatattatatta", data)
    //     data.length === 0 ? console.log("no data") : console.log("data", data)
    // }
    return (
        <>
            <table className='w-[calc(100%_-_20px)] m-2.5 border-0 ' cellSpacing="0" cellPadding="0" border="0" >
                
                    <thead>
                            <th className="text-left pb-[3px]" colSpan={3}>
                                <div className="w-full text-[13px] text-white font-extralight tracking-[-0.8px] leading-[55px] h-[55px] bg-contain px-[18px] border-t-[3px] bg-charcoal border-t-aquaBlue flex items-center justify-between">
                                    <span className="text-xl">{notice ? "공지사항" : "이벤트" }</span>
                                    <Link to={notice ? "/notice" : "/event"} className="">더보기</Link>
                                </div>
                            </th>
                    </thead>
                    <tbody>
                    {data?.map((item, index) => (
                        <tr key={index} className='h-10 bg-charcoal odd:bg-obsidian'>
                            <td className='text-white font-thin ps-2.5 text-[15px]'>
                                <a href={notice ? `/notice/single-notice/${item.id}` : `/event/single-event/${item.id}`} className='ng-binding'><span className='text-gold'>{notice ? '※' : '♥'}</span> {item.title} <span className='text-gold'>{notice ? '※' : '♥'}</span></a>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </>
    )
}

export default NoticeEventTableComponent